export const initBlogAuthor = () => {
  // Function to hide authors named Aaron
  function hideAaronAuthors() {
    const blogAuthors = document.querySelectorAll(
      '.dpdfg_filtergrid .dp-dfg-item .dp-dfg-meta .author a',
    );

    blogAuthors.forEach((author) => {
      if (author.textContent.includes('Aaron')) {
        author.style.display = 'none';
      }
    });
  }

  // Function to hide author on single post pages
  function hideSinglePostAuthor() {
    const blogPost = document.querySelector('.single-post');
    const blogAuthor = document.querySelector('.et_pb_post_title .author');
    const postDate = document.querySelector(
      '.et_pb_post_title .et_pb_title_meta_container .published',
    );

    if (blogPost && blogAuthor && blogAuthor.textContent.includes('Aaron')) {
      blogAuthor.style.display = 'none';
      postDate?.classList.add('remove-author');
    }
  }

  // Run on initial page load
  document.addEventListener('DOMContentLoaded', () => {
    hideAaronAuthors();
    hideSinglePostAuthor();

    // Set up MutationObserver for AJAX-loaded content
    const targetNode = document.querySelector('.dpdfg_filtergrid');
    if (targetNode) {
      const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (
            mutation.type === 'childList' &&
            mutation.addedNodes &&
            mutation.addedNodes.length > 0
          ) {
            hideAaronAuthors();
          }
        });
      });

      observer.observe(targetNode, {
        childList: true,
        subtree: true,
      });
    }
  });
};
